
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class DHT11 extends BasePeripheral {
    constructor() {
        super();
        this.id = 'dht11';
        this.name = 'DHT11 Temperature Humidity Sensor';
        const settings: Array<Setting> = [
            {
                id: 'SDA',
                name: 'SDA',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            {
                id: 'TEMPERATURE',
                name: 'Temperature',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'TEMP',
            },
            {
                id: 'HUMIDITY',
                name: 'Humidity',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'HUM',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
